import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { fetchAuthSession } from 'aws-amplify/auth';
import { from, Observable, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class GraphqlAuthInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url !== environment.baseUrl) {
      return next.handle(request);
    }

    return from(fetchAuthSession()).pipe(
      switchMap((session) => {
        const idToken = session.tokens?.idToken?.toString();

        if (!idToken) {
          return next.handle(request);
        }

        const headers = request.headers
          .delete('x-api-key')
          .set('Authorization', idToken);

        return next.handle(request.clone({ headers }));
      })
    );
  }
}
